import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {ProfileComponent} from './profile.component';
import {ChangePasswordComponent} from './change-password/change-password.component';

import {ProfileService} from './services/profile.service';

import {FieldsModule} from '../../components/fields/fields.module';
import {CommonComponentsModule} from '../../common-components.module';
import {SafeHtmlPipeModule} from '../../pipes/safe-html/safe-html-pipe.module';
import {ChangeWaiverSettingsModalComponent} from './change-waiver-settings-modal/change-waiver-settings-modal.component';
import {SignaturePadModule} from 'angular2-signaturepad';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {UtilsModule} from '../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        FieldsModule,
        CommonComponentsModule,
        SafeHtmlPipeModule,
        SignaturePadModule,
        PdfViewerModule,
        AngularMaterialImportModule,
        UtilsModule
    ],
    declarations: [
        ProfileComponent,
        ChangePasswordComponent,
        ChangeWaiverSettingsModalComponent
    ],
    providers: [ProfileService]
})
export class ProfileModule {
}



// WEBPACK FOOTER //
// /app/src/app/views/profile/profile.module.ts